import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ResetSuccess from "components/Reset/ResetSuccess";

class ResetSuccessContainer extends React.PureComponent {
  render() {
    return <ResetSuccess {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = (state) => ({});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ResetSuccessContainer);
